
import { Component, OnInit } from '@angular/core';
import { Reward } from '../../models/reward';
import { GamificationService } from '../../service/gamification.service';
import { NotificationService } from '../../service/notification.service';

@Component({
    selector: 'app-rewards',
    templateUrl: './rewards.component.html',
    styleUrls: ['./rewards.component.scss'],
})
export class RewardsComponent implements OnInit {
    rewards: Reward[] = [];

    constructor(
        private gamificationService: GamificationService,
        private notificationService: NotificationService
    ) {}

    ngOnInit() {
        this.loadRewards();
    }

    private loadRewards() {
        // Implementa il caricamento delle rewards dal service
    }

    claimReward(reward: Reward) {
        if (reward.unlocked) {
            this.notificationService.showNotification({
                message: `Hai ottenuto: ${reward.name}!`,
                type: 'reward',
                icon: reward.icon
            });
            // Implementa la logica per assegnare la reward
        }
    }
}